import {
  BusinessType,
  isBusinessTypeEnabled,
  PAGE_PORTAL_COMPANY,
  PORTAL_PREFIX
} from "@kivunova/kivufrontendcommon";
import { UserRole } from "../components/Profile/enums/profileEnums";
import { buildSidebarNavItems } from "./buildSidebarNavItems";
import { RETAIL_SIDEBAR_CONFIG } from "./config/retailSidebarConfig";
import { SIDEBAR_CONFIG_BY_BUSINESS_TYPE } from "./config/sidebarConfigByBusinessType";
import { translateOrganizationLabels } from "../config/organizationVerbiageConfig";
import type {
  SidebarNavItem,
  SidebarTranslateFn
} from "./types/sidebarNavTypes";

const companyProfilePath = `${PORTAL_PREFIX}/${PAGE_PORTAL_COMPANY}`;

export const getSidebarItems = (
  t: SidebarTranslateFn,
  role: UserRole,
  businessType: BusinessType | string = BusinessType.RETAIL,
  featureFlags: Record<string, boolean> = {}
): SidebarNavItem[] => {
  const resolvedType = isBusinessTypeEnabled(businessType, featureFlags)
    ? businessType
    : BusinessType.RETAIL;

  const config =
    SIDEBAR_CONFIG_BY_BUSINESS_TYPE[resolvedType as BusinessType] ??
    RETAIL_SIDEBAR_CONFIG;

  const orgLabels = translateOrganizationLabels(t, resolvedType);
  const items = buildSidebarNavItems(config, t, role);

  return items.map((item) =>
    item.path === companyProfilePath
      ? { ...item, label: orgLabels.sidebarProfile }
      : item
  );
};
